// DS1.7.5
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import s from './ThumbStatusIndicator.scss';
const validCombinations = {
    'in-tier': [
        'large',
        'medium',
        'small'
    ],
    'in-premium': [
        'large',
        'medium'
    ],
    'in-watchers-only': [
        'large',
        'medium'
    ],
    commission: [
        'large',
        'medium',
        'small'
    ],
    adoptable: [
        'large',
        'medium',
        'small'
    ],
    pcp: [
        'medium'
    ],
    nft: [
        'medium'
    ]
};
const fileNameMap = {
    'in-tier': 'tier',
    'in-premium': 'pg',
    'in-watchers-only': 'watchers',
    pcp: 'pcp',
    adoptable: 'adopt',
    commission: 'commission'
};
const ThumbStatusIndicator = ({ type , size , className  })=>{
    // not all combinations exist
    if (!validCombinations[type].includes(size)) {
        return null;
    }
    var _fileNameMap_type;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[size], className)
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "",
        className: s['image'],
        src: Url.staticCDNLink(`eclipse/global/svg/deviation-status-icons/v2/${(_fileNameMap_type = fileNameMap[type]) !== null && _fileNameMap_type !== void 0 ? _fileNameMap_type : type}-${size}.svg?2`)
    }));
};
ThumbStatusIndicator.displayName = 'ThumbStatusIndicator';
export default ThumbStatusIndicator;
